import { ERROR_MESSAGES } from "@config/messages";

export default function ErrorFallback() {
  return (
    <div
      role="alert"
      className="flex w-2/4 flex-col items-center justify-center rounded-lg border bg-background-tertiary dark:bg-gray-800 py-8"
    >
      <p className="text-gray-800 dark:text-invertedPrimary80">{ERROR_MESSAGES.GENERIC}</p>
    </div>
  );
}
